module.exports = __webpack_public_path__ + "static/img/1060.88e0b8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1060.jpg
// module id = 242
// module chunks = 0